import { useState } from "react";
import { quickCheckTabs } from "@/mocks/homeData";

export default function QuickCheck() {
  const [active, setActive] = useState(quickCheckTabs[0].key);
  const current = quickCheckTabs.find((t) => t.key === active) ?? quickCheckTabs[0];
  const [done, setDone] = useState<number[]>([]);

  const toggle = (i: number) => {
    setDone((prev) => (prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]));
  };

  const switchTab = (key: string) => {
    setActive(key);
    setDone([]);
  };

  const progress = Math.round((done.length / current.items.length) * 100);

  return (
    <section id="quickcheck" className="w-full bg-secondary-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-secondary-700 uppercase tracking-wider">
              <i className="ri-flashlight-line"></i>
              Quick Check
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              三分钟自检清单，按设备逐条勾选
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              勾选你已经在做的动作，没勾上的就是还没排查的环节。清单只作用于本页内容，
              帮你把「随手试试」变成有顺序的排查。
            </p>
          </div>
        </div>

        <div className="mt-7 inline-flex flex-wrap p-1 rounded-full bg-background-100 border border-background-200">
          {quickCheckTabs.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => switchTab(t.key)}
              aria-pressed={active === t.key}
              className={`inline-flex items-center gap-1.5 whitespace-nowrap px-4 py-2 rounded-full text-xs md:text-sm transition-colors cursor-pointer ${
                active === t.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-700"
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={t.icon}></i>
              </span>
              {t.label}
            </button>
          ))}
        </div>

        <div className="mt-6 rounded-lg bg-background-50 border border-background-200/80 overflow-hidden">
          <div className="flex items-center justify-between gap-4 px-5 md:px-7 py-4 border-b border-background-200/70">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-lg">
                <i className={current.icon}></i>
              </span>
              <p className="font-heading text-base md:text-lg font-semibold text-foreground-950">{current.label}</p>
            </div>
            <div className="flex items-center gap-3">
              <div className="hidden sm:block w-32 h-1.5 rounded-full bg-background-200 overflow-hidden">
                <div
                  className="h-full bg-primary-500 transition-all duration-500"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {done.length} / {current.items.length}
              </span>
            </div>
          </div>

          <ul className="divide-y divide-background-200/60">
            {current.items.map((item, i) => {
              const checked = done.includes(i);
              return (
                <li key={item}>
                  <button
                    type="button"
                    onClick={() => toggle(i)}
                    aria-pressed={checked}
                    className="w-full text-left flex items-start gap-3 md:gap-4 px-5 md:px-7 py-4 hover:bg-background-100 transition-colors cursor-pointer"
                  >
                    <span
                      className={`mt-0.5 w-5 h-5 rounded-md border flex items-center justify-center text-xs shrink-0 transition-colors ${
                        checked
                          ? "bg-primary-500 border-primary-500 text-background-50"
                          : "border-background-300 text-transparent"
                      }`}
                    >
                      <i className="ri-check-line"></i>
                    </span>
                    <span
                      className={`text-sm leading-relaxed ${
                        checked ? "text-foreground-400 line-through" : "text-foreground-700"
                      }`}
                    >
                      {item}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}